import React from 'react';
import connect from '../reduxConnect'

import { Paginator } from './TablePaginator';
import CompactPaginator from 'components/CompactPaginator';

import isEmpty from 'lodash/isEmpty';

const Pagination = ({ isLoading, pagination: { itemsPerPage, ...pagination }, onChangePageNumber, data }) => (
  <Paginator
    onPageChange={ onChangePageNumber }
    isLoading={ isLoading }
    isDataEmpty={ isEmpty(data) }
    { ...pagination }
  />
);

export default connect(Pagination);

// FIN-1297: the pager of the strip — the compact one, as wide with 300 pages as with 3; the full
// one stays under the table.
export const StripPaginator = connect(({ pagination: { activePage, totalPages }, onChangePageNumber }) => (
  <CompactPaginator activePage={activePage} totalPages={totalPages} onPageChange={onChangePageNumber} />
));
